import Vue from "vue";
import CharacterCount from "./characterCount";
import BuilderModel from "../../../../common/models/tracked/builderModel";

export default class CharacterCountFactory {
  static create(parent: BuilderModel, fieldName: string = 'character_count'): CharacterCount {
    return CharacterCountFactory.createFor(parent, fieldName);
  }

  private static createFor(parent: BuilderModel, fieldName: string) {
    const characterCount: CharacterCount = new CharacterCount();
    characterCount.rootModel = parent.rootModel;

    characterCount.defineProperty<CharacterCount>(
        'min',
        null,
        false,
        (model, oldVal, newVal) => {
          model.beforeSetCallback();
        },
        (model, oldVal, newVal) => {
          model.afterSetCallback();
        }
    );
    characterCount.defineProperty<CharacterCount>(
        'max',
        null,
        false,
        (model, oldVal, newVal) => {
          model.beforeSetCallback();
        },
        (model, oldVal, newVal) => {
          model.afterSetCallback();
        }
    );
    characterCount.defineProperty('show_char_limit', false);
    characterCount.defineProperty('char_limit_message', null);

    characterCount.parent = parent;
    Vue.set(parent, fieldName, characterCount);

    return characterCount;
  }
}